
<div class="dialog-header">
  <mat-icon class="warning-icon">warning</mat-icon>
<h2 mat-dialog-title> {{ data.title }}</h2>
</div>
<mat-dialog-content class="dialog-content">
  {{ data.text }}
  <mat-form-field *ngIf="data.showReasonInput" appearance="outline" style="width: 100%; margin-top: 12px;">
    <mat-label>{{ data.reasonLabel || 'Reason' }}</mat-label>
    <textarea matInput [(ngModel)]="reasonText" rows="3"
      [maxlength]="data.reasonMaxLength || 500"></textarea>
    <mat-hint *ngIf="data.reasonMinLength && reasonText.length < data.reasonMinLength">
      Minimum {{ data.reasonMinLength }} characters required
    </mat-hint>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [mat-dialog-close]="false" *ngIf="!data.hideCancel">Cancel</button>
  <button mat-raised-button color="warn"
    [mat-dialog-close]="data.showReasonInput ? reasonText : true"
    [disabled]="data.showReasonInput && (!reasonText?.trim() || (data.reasonMinLength && reasonText.trim().length < data.reasonMinLength))">{{data.subText}}</button>
</mat-dialog-actions>
